import { MutableRefObject } from 'react';
import PaginationPresentation from './PaginationPresentation';
import { useSelector } from 'react-redux';

interface PaginationContainerProps {
  appliedPageNumber?: number;
  onChangePageHandler: (pageNumber: number) => void;
  totalResultsDisplayed: number;
  pageRangeDisplayed?: number;
  cardsPerPage?: number;
  scrollPostion?: MutableRefObject<HTMLElement | null>;
  scrollTop?: number;
}

interface SelectedEventProps {
  selected: number;
}
const PaginationContainer = ({
  appliedPageNumber,
  onChangePageHandler,
  totalResultsDisplayed,
  pageRangeDisplayed,
  cardsPerPage,
  scrollPostion,
  scrollTop
}: PaginationContainerProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);

  const onChange = (event: SelectedEventProps) => {
    onChangePageHandler(event.selected + 1);

    if (scrollPostion && scrollPostion.current && !isMobile) {
      const y =
        scrollPostion.current.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({ top: y - 200, behavior: 'smooth' });
    } else if (scrollTop != undefined) {
      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });
    }
  };

  return (
    <PaginationPresentation
      handlePageClick={onChange}
      appliedPageNumber={appliedPageNumber}
      totalResultsDisplayed={totalResultsDisplayed}
      pageRangeDisplayed={pageRangeDisplayed}
      cardsPerPage={cardsPerPage}
    />
  );
};

export default PaginationContainer;
